import React, { useState } from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  apicall,
  pageCount,
  setPageCount,
  current_page,
  setCurrent_page,
}) => {
  
  const handlePageClick = (count) => {
    setCurrent_page(count.selected + 1);
  };
  return (
    <>
      <div className="paginationbar d-sm-flex justify-content-between align-items-center bg-color-3 bg-color-1-dark p-3 mt-4">
        <ReactPaginate
          breakLabel="..."
          // nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          // previousLabel="< previous"
          renderOnZeroPageCount={null}
        />
        <p className="text level-7 mb-0 mt-sm-0 primary-medium-font inner-color body-color-dark">
          {/* Showing 1 To {pageCount} Of {current_page} */}
          {apicall?.length > 0 ? (
            <p className="total-pages">Showing {current_page} To {apicall?.length}</p>
          ) : null}
          {/* (15 Pages) */}
        </p>
      </div>
    </>
  );
};

export default Pagination;
